import Spinner from 'ui/src/spinner';
import Center from 'ui/src/center';
import { getFragmentData } from '@client/graphql/types';
import { OnlineOrderBranchSettingFragment } from '@client/graphql/online-order-branch-setting-fragment';
import ApplicationErrorView from '@client/module/error/application-error-view';
import { useLocation } from 'react-router-dom';
import OnlineOrderBranchSettingEditDelivery from '@client/page/management/online-order/setting/component/online-order-branch-setting-edit-delivery.tsx';
import OnlineOrderBranchSettingEditGeneral from '@client/page/management/online-order/setting/component/online-order-branch-setting-edit-general.tsx';
import OnlineOrderBranchSettingEditPickup from '@client/page/management/online-order/setting/component/online-order-branch-setting-edit-pickup.tsx';
import OnlineOrderBranchPrinterSettingEdit from '@client/page/management/online-order/setting/component/online-order-printer.tsx';
import { useFocusedBranchContext } from '../../table-group/table-group-list/component/branch-selection/focused-branch-context.ts';
import useOnlineOrderBranchSetting from './logic/use-online-order-branch-setting';
import OnlineOrderBranchSettingSetup from './component/online-order-branch-setting-setup';

export default function OnlineOrderBranchSettingPage() {
  // Params
  const branchProvider = useFocusedBranchContext();
  const branchID = branchProvider.branch?.id ?? '';

  // Hooks
  const { data, loading, error } = useOnlineOrderBranchSetting(branchID);
  const location = useLocation();
  // Data
  const onlineOrderBranchSettingData = getFragmentData(
    OnlineOrderBranchSettingFragment,
    data?.onlineOrderBranchConfiguration
  );

  // Safety check
  if (loading) {
    return (
      <Center className="p-8">
        <Spinner />
      </Center>
    );
  }

  if (error) {
    return <ApplicationErrorView error={error} />;
  }

  return (
    <>
      {onlineOrderBranchSettingData ? (
        <>
          {location.pathname === '/online-order/setting/delivery' && (
            <OnlineOrderBranchSettingEditDelivery onlineOrderBranchSettingData={onlineOrderBranchSettingData} />
          )}
          {location.pathname === '/online-order/setting/pick-up' && (
            <OnlineOrderBranchSettingEditPickup onlineOrderBranchSettingData={onlineOrderBranchSettingData} />
          )}
          {location.pathname === '/online-order/setting/general' && (
            <OnlineOrderBranchSettingEditGeneral onlineOrderBranchSettingData={onlineOrderBranchSettingData} />
          )}

          {location.pathname === '/online-order/setting/printer' && (
            <OnlineOrderBranchPrinterSettingEdit onlineOrderBranchSettingData={onlineOrderBranchSettingData} />
          )}
        </>
      ) : (
        <OnlineOrderBranchSettingSetup branchID={branchID} />
      )}
    </>
  );
}
